import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { PageSection } from '@app/core/components/PageSection';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { publishMessages } from '@app/modules/social-export/publish';
import { useComposition } from '../../hooks/useComposition';
import { ComposeSocialExportPanorama } from './ComposeSocialExportPanorama';
import { ComposeSocialExportPublishDropdown } from './ComposeSocialExportPublishDropdown';
import { useCompositionSocialUploadsQuery } from './useCompositionSocialUploadsQuery';

/**
 * Composition social export block: platform bar first, then uploads list.
 */
export function ComposeSocialPublishView() {
  const { composition } = useComposition();
  const uploadsQuery = useCompositionSocialUploadsQuery(composition.id);

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <QueryView query={uploadsQuery} inline>
        {() => {
          const publicationsCount = Array.from(uploadsQuery.data?.values() ?? []).flat().length;

          return (
            <Box>
              <PageSection message={publishMessages.publishToSectionTitle}>
                <ComposeSocialExportPublishDropdown />
              </PageSection>
              <PageSection
                message={publishMessages.publicationsSectionTitle}
                values={{ count: publicationsCount }}
              >
                <ComposeSocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
              </PageSection>
            </Box>
          );
        }}
      </QueryView>
    </IfPermission>
  );
}
